import { useState } from 'react';
import { motion } from 'framer-motion';
import AnimatedWhatsApp from '../icons/AnimatedWhatsApp';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const phoneNumber = '+34687999427'; // Número de GT Race
  const message = 'Hola, estoy interesado en conocer más sobre GT Race Marbella';

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
    >
      {isHovered && (
        <motion.div
          initial={{ opacity: 0, x: 10 }}
          animate={{ opacity: 1, x: 0 }}
          className="absolute right-16 top-1/2 -translate-y-1/2 bg-black text-gt-gold border border-gt-gold/40 px-4 py-2 rounded-lg shadow-lg whitespace-nowrap"
        >
          <p className="font-medium">¡Contáctanos!</p>
        </motion.div>
      )}

      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-gt-gold/40 animate-ping" />
        <div className="relative rounded-full p-3.5 bg-gradient-to-br from-gray-900 to-black border-2 border-gt-gold shadow-2xl shadow-black/60 group-hover:shadow-gt-gold/30 transition-shadow">
          <AnimatedWhatsApp className="w-8 h-8" />
        </div>
      </div>
    </motion.a>
  );
};

export default WhatsAppButton;
